import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Calendar, MapPin, Clock, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Events = () => {
  const upcomingEvents = [{
    title: 'Networking Salon - Warri Edition',
    date: 'August 30, 2025',
    location: 'Warri, Nigeria',
    time: '4:00 PM - 7:00 PM',
    description: 'Join us for an evening of meaningful connections, inspiring conversations, and opportunities in Warri.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1BbFm8kmubumv56AGcAZxq/1755202597061.jpg',
    link: '/events/warri-2025'
  }, {
    title: 'Berlin Creative Salon',
    date: 'September 15, 2025',
    location: 'Berlin, Germany',
    time: '6:00 PM - 9:00 PM',
    description: "Connect with Berlin's creative community in this special edition of The Networking Salon.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg'
  }, {
    title: 'Lagos Tech Meetup',
    date: 'October 5, 2025',
    location: 'Lagos, Nigeria',
    time: '4:00 PM - 7:00 PM',
    description: 'A focused networking event for tech professionals, entrepreneurs, and innovators in Lagos.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg'
  }, {
    title: 'Benin City Salon',
    date: 'November 10, 2025',
    location: 'Benin City, Nigeria',
    time: '3:00 PM - 6:00 PM',
    description: 'Expanding our community in Benin City with this special networking event for professionals and changemakers.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aftEvNay6iufkLwXy7PyxK/1755202597036.jpg'
  }];
  return <div className="pt-20" data-id="element-2401">
      <section className="py-16 bg-secondary/5" data-id="element-2402">
        <div className="container mx-auto px-4" data-id="element-2403">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2404">
            Upcoming Events
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-2405">
            Join us at one of our upcoming networking salons around the world.
            Connect with professionals, share ideas, and discover new
            opportunities.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-2406">
        <div className="container mx-auto px-4" data-id="element-2407">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-2408">
            {upcomingEvents.map((event, index) => <Card key={index} className="flex flex-col" data-id="element-2409">
                <div className="relative aspect-[16/9] border-2 border-gray-300 mb-4 overflow-hidden" data-id="element-2410">
                  <img src={event.image} alt={event.title} className="w-full h-full object-cover" data-id="element-2411" />
                </div>
                <h3 className="text-xl font-bold text-secondary-dark" data-id="element-2412">
                  {event.title}
                </h3>
                <p className="text-secondary mt-2 mb-4" data-id="element-2413">{event.description}</p>
                <div className="mt-auto space-y-2" data-id="element-2414">
                  <div className="flex items-center" data-id="element-2415">
                    <Calendar size={18} className="mr-2 text-primary" data-id="element-2416" />
                    <span data-id="element-2417">{event.date}</span>
                  </div>
                  <div className="flex items-center" data-id="element-2418">
                    <MapPin size={18} className="mr-2 text-primary" data-id="element-2419" />
                    <span data-id="element-2420">{event.location}</span>
                  </div>
                  <div className="flex items-center" data-id="element-2421">
                    <Clock size={18} className="mr-2 text-primary" data-id="element-2422" />
                    <span data-id="element-2423">{event.time}</span>
                  </div>
                  <div className="mt-4" data-id="element-2424">
                    {event.link ? <Link to={event.link} data-id="element-2425">
                        <Button variant="outline" className="w-full" data-id="element-2426">
                          View Details
                        </Button>
                      </Link> : <Button variant="outline" className="w-full" data-id="element-2427">
                        RSVP
                      </Button>}
                  </div>
                </div>
              </Card>)}
          </div>
          <div className="border-2 border-gray-300 rounded-lg overflow-hidden" data-id="element-2428">
            <div className="p-4 bg-secondary/5 border-b border-gray-300" data-id="element-2429">
              <h2 className="text-xl font-bold text-secondary-dark flex items-center" data-id="element-2430">
                <Calendar size={20} className="mr-2" data-id="element-2431" />
                Event Calendar
              </h2>
            </div>
            <div className="p-4" data-id="element-2432">
              <iframe src="https://calendar.google.com/calendar/embed?src=socialnetworkingimmersion%40gmail.com&ctz=Africa%2FLagos" style={{
              border: 0
            }} width="100%" height="600" frameBorder="0" scrolling="no" className="border border-gray-200 rounded" data-id="element-2433"></iframe>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-2434">
            <p className="text-secondary mb-6" data-id="element-2435">
              Want to host a Networking Salon in your city? Become a city lead
              and help build our community.
            </p>
            <Button data-id="element-2436">Become a City Lead</Button>
          </div>
        </div>
      </section>
    </div>;
};